import React from 'react';
import { Spinner } from 'reactstrap';
import { useTenant } from '../../../../hooks/useTenant';
import { useProfessorExpiringStudents } from '../hooks/useProfessorExpiringStudents';

const ProfessorExpiringStudents = ({ professor }) => {
    const { idTenant } = useTenant();
    const { expiringStudents, loading } = useProfessorExpiringStudents(idTenant, professor.idEmployee, professor.period);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center py-5">
                <Spinner color="light" size="sm" />
                <span className="ms-2 text-white-50 font-size-14">Carregando alunos em risco...</span>
            </div>
        );
    }

    if (!expiringStudents || expiringStudents.length === 0) {
        return (
            <div style={{ padding: '0 8px', marginBottom: '40px' }}>
                <div className="p-4 text-center"
                    style={{
                        backgroundColor: 'rgba(255,255,255,0.02)',
                        borderRadius: '20px',
                        border: '1px dashed rgba(255,255,255,0.1)'
                    }}>
                    <i className="mdi mdi-check-circle-outline font-size-30 text-success mb-2 d-block"></i>
                    <h5 className="fw-bold text-white mb-1">Nenhum aluno em risco!</h5>
                    <p className="font-size-13 text-white-50 mb-0">Nenhum plano de alunos desta turma vencerá neste período.</p>
                </div>
            </div>
        );
    }

    return (
        <div style={{ padding: '0 8px', marginBottom: '40px' }}>
            <div className="p-3 p-md-4"
                style={{
                    backgroundColor: 'rgba(255,255,255,0.04)',
                    borderRadius: '20px',
                    border: '1px solid rgba(255,255,255,0.06)',
                    backdropFilter: "blur(10px)"
                }}>

                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3 mb-4 mt-2 px-2">
                    <div className="text-center text-sm-start">
                        <h4 className="mb-0 fw-bold font-size-20 font-size-md-22" style={{ color: "rgba(255,255,255,0.9)" }}>
                            Alunos em Risco de Abandono
                        </h4>
                        <p className="font-size-13 text-white-50 mb-0 mt-1">Foque na renovação destes alunos este mês</p>
                    </div>
                    <div className="text-center text-sm-end">
                        <span className="badge rounded-pill font-size-14 px-3 py-2"
                            style={{ backgroundColor: "rgba(244, 106, 106, 0.15)", color: "#f46a6a", border: "1px solid rgba(244, 106, 106, 0.3)" }}>
                            {expiringStudents.length} {expiringStudents.length === 1 ? 'Aluno' : 'Alunos'}
                        </span>
                    </div>
                </div>

                <div className="d-flex flex-column gap-2 px-1">
                    {expiringStudents.map((student) => {
                        const dateEnd = new Date(`${student.endDate}T12:00:00`);
                        const formattedDate = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short' }).format(dateEnd);

                        return (
                            <div key={student.id}
                                className="d-flex align-items-center justify-content-between gap-3 py-3 px-3 rounded-3"
                                style={{
                                    background: "rgba(255,255,255,0.02)",
                                    border: "1px solid rgba(255,255,255,0.04)",
                                    transition: "all 0.2s"
                                }}>

                                {/* Foto e Nome */}
                                <div className="d-flex align-items-center gap-3 flex-grow-1 overflow-hidden">
                                    <div style={{ width: "45px", height: "45px", borderRadius: "50%", flexShrink: 0, overflow: "hidden", backgroundColor: "rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        {student.photoUrl ? (
                                            <img src={student.photoUrl} alt={student.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                        ) : (
                                            <i className="mdi mdi-account text-white-50 font-size-24"></i>
                                        )}
                                    </div>
                                    <div className="overflow-hidden">
                                        <div className="fw-semibold font-size-15 text-white text-truncate">
                                            {student.name}
                                        </div>
                                        <div className="font-size-12" style={{ color: "rgba(255,255,255,0.5)" }}>
                                            Vence dia {formattedDate}
                                        </div>
                                    </div>
                                </div>

                                {/* Risco */}
                                <div className="text-end flex-shrink-0 d-flex flex-column align-items-end">
                                    <span className="badge rounded-pill font-size-12 px-2 py-1"
                                        style={{ backgroundColor: `${student.riskColor}22`, color: student.riskColor, border: `1px solid ${student.riskColor}44` }}>
                                        <i className="mdi mdi-alert-circle-outline me-1"></i>
                                        Risco {student.risk}
                                    </span>
                                    <span className="font-size-11 mt-1" style={{ color: "rgba(255,255,255,0.3)" }}>
                                        {student.diffDays > 0 ? `em ${student.diffDays} dias` : 'Vencido'}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ProfessorExpiringStudents;
